export const LOGO_SRC = "/logo.png";

export function Logo({ light = false, size = "md", className = "" }) {
  const h = size === "lg" ? "h-16" : size === "sm" ? "h-9" : "h-12";
  return (
    <span className={`logo-shine inline-flex items-center overflow-hidden rounded-xl ${className}`}>
      <img
        src={LOGO_SRC}
        alt="Melwest Eco Energy"
        className={`${h} w-auto ${light ? "bg-white px-2.5 py-1.5" : ""}`}
      />
    </span>
  );
}

export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <span className={`logo-shine inline-flex items-center justify-center overflow-hidden rounded-lg bg-white ${className}`}>
      <img src={LOGO_SRC} alt="" className="h-[85%] w-[85%] object-contain" />
    </span>
  );
}
